export default {
  overrideRequest: function (axiosConfig) {

  },
  registercustomer: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  verifyemailbysession: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  verifyemailbyusernameandpassword: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  verifyphonebysession: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  verifyphonebyusernameandpassword: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  resendpintoemail: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  resendpintophone: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  getcustomercontext: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  getsabytempsession: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  getsabyusernameandpassword: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  get2fa: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  get2famock: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  sendpinbytempsession: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  sendpinbyusernameandpassword: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  setpasswordbytempsession: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  setpasswordbysession: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  getpersonaldetails: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  updatepersonaldetails: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  uploadimages: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
      axiosConfig.uploadFile = true
    }
  },
  w2glist: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  resetpwdsa: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  registerfirebasenotification: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  acknowledgesuspension: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  longtermsuspend: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  shorttermsuspend: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  sendpin2verifyphone: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  sendpin2verifyemail: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  setpcpromotions4customer: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  logcustomeraccess: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  getaccountperiodstats: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  setpromocode4customerextended: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  savepersonaldetails: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  verifyphone: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  verifyemail: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  pairauthenticator: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  setmarketingpreferences: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  codesgenerate: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  passwordset: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  untrustdevice: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  recover: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
    }
  },
  uploadcustomdocuments: {
    overrideRequest: function (axiosConfig) {
      axiosConfig.method = 'post'
      axiosConfig.uploadFile = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/library/rpcService/api/services/IW.js